<template>
    <div class="lottery-wrapper">
        <ul>
            <li
                v-for="(item, index) in Records"
                :key="item.id"
                :class="current === index ? 'current' : ''"
            >
                <img :src="item.icon" alt="" />
                <h4>{{ item.name }}</h4>
            </li>
        </ul>
        <div class="info-wrapper">
            <UserInfo />
            <div class="times">
                剩余抽奖次数<strong>{{ user.lottery_count }}</strong>
            </div>
        </div>
        <div class="btn-lottery" @click="lotteryEvent">点击抽奖</div>
    </div>
    <Teleport to=".container">
        <ResultPop ref="resultRef" />
    </Teleport>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, reactive, inject, computed } from "vue";
import UserInfo from "@/components/user-info.vue";
import useStore from "@/store/store";
import Records from "@/config/rewards";
import { Lottery } from "@/api";
import { Sleep } from "@/utils";
import REWARDS from "@/config/rewards";
import ResultPop from "./pop-result.vue";
const resultRef = ref(null);
const loginRef = inject("loginRef");
const bindRef = inject("bindRef");
const { user } = storeToRefs(useStore());

const state = reactive({
    index: -1,
    playing: false,
    timer: null
});

const current = computed(() => {
    return state.index >= 0 ? state.index % 9 : -1;
});

// 抽奖
const lotteryEvent = async () => {
    if (!user.value.islogin) {
        return loginRef.value.Show();
    }
    if (!user.value.rolename) {
        return bindRef.value.Show();
    }
    if (user.value.lottery_count <= 0) {
        return CsGame.alert("您的抽奖次数不足！", 1200, "error");
    }
    if (state.playing) {
        return false;
    }
    state.playing = true;
    const res = await Lottery();
    if (res) {
        user.value.lottery_count -= 1;
        const index = REWARDS.findIndex((item) => item.id == res.rewardid),
            end = index + 9 * 3,
            reward = {
                ...REWARDS[index],
                logid: res.logid,
                cardid: res.cardid
            };
        clearInterval(state.timer);
        state.timer = setInterval(async () => {
            state.index++;
            if (state.index >= end) {
                clearInterval(state.timer);
                await Sleep(800);
                state.playing = false;
                state.index = -1;
                resultRef.value.Show(reward);
            }
        }, 100);
    }
};
</script>

<style lang="scss" scoped>
.lottery-wrapper {
    padding-top: 10px;
    ul {
        display: grid;
        grid-template-columns: repeat(3, 370px);
        grid-template-rows: repeat(3, 219px);
        grid-gap: 20px;
        justify-content: center;
        grid-gap: 40px;
        li {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lottery-bg.png");
            font-size: 18px;
            color: #ffdb9b;
            &.current {
                background-position: -454px 0px;
            }
            img {
                margin-bottom: 10px;
            }
        }
    }
    .info-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #e2a13e;
        margin: 30px auto;
        .times {
            margin-left: 12px;
            strong {
                color: #0ce717;
                margin-left: 6px;
            }
        }
    }
    .btn-lottery {
        width: 352px;
        height: 109px;
        line-height: 120px;
        cursor: pointer;
        margin: 0px auto;
        text-align: center;
        font-size: 32px;
        color: #792520;
        background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/btn-bg.png");
        &:hover {
            background-position: 0px -131px;
        }
    }
}
</style>
